<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de Atendimentos Odontológicos">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/atencao-basica/relatorio-atendimento-odontologico/List'

export default {
    components: { List },
}
</script>